import { Button } from "@material-ui/core";
import Card from "@material-ui/core/Card";
import Container from "@saleor/components/Container";
import PageHeader from "@saleor/components/PageHeader";
import useUser from "@saleor/hooks/useUser";
import { sectionNames } from "@saleor/intl";
import { SearchRunner_search_edges_node } from "@saleor/storeOrders/types/SearchRunner";
import { StoreOrderListUrlSortField } from "@saleor/storeOrders/urls";
import { FilterPageProps, PageListProps, SortPage } from "@saleor/types";
import {
  SmopOrderStatusEnum,
  SmopUserTypeCode
} from "@saleor/types/globalTypes";
import { generatePdf } from "@saleor/utils/pdf/handler";
import React, { useState } from "react";
import { useIntl } from "react-intl";

import { StoreOrderList_storeOrders_edges_node } from "../../types/StoreOrderList";
import FilterBar from "../StoreOrderFilterBar";
import StoreOrderList from "../StoreOrderList";
import GenerateParcelIdDialog from "./components/GenerateParcelIdDialog";
import {
  createFilterStructure,
  StoreOrderFilterKeys,
  StoreOrderListFilterOpts
} from "./filters";

interface RunnerFormData {
  runnerId: string;
  storeOrderId: string;
}
export interface StoreOrderListPageProps
  extends PageListProps,
    FilterPageProps<StoreOrderFilterKeys, StoreOrderListFilterOpts>,
    SortPage<StoreOrderListUrlSortField> {
  disableAction: boolean;
  disableMallActions: boolean;
  enableManageMallActions: boolean;
  openGenerateModal: () => void;
  onAssignRunner: (orderId: string) => void;
  onSubmitRunner: (data: RunnerFormData) => void;
  runnerList: SearchRunner_search_edges_node[];
  fetchRunner: (query: string) => void;
  fetchMoreRunner: any;
  onOverrideStatus: (
    orderId: string,
    orderStatus: SmopOrderStatusEnum,
    newOrderStatus: SmopOrderStatusEnum
  ) => void;
  onUpdateStatus: (
    orderId: string,
    orderStatus: SmopOrderStatusEnum,
    newOrderStatus: SmopOrderStatusEnum
  ) => void;
  activeTab;
  orders: StoreOrderList_storeOrders_edges_node[];
  queryVariables;
  isOpsAdminView: boolean;
  setOrderMallId: React.Dispatch<React.SetStateAction<string>>;
  openModal();
}

const StoreOrderListPage: React.FC<StoreOrderListPageProps> = ({
  disableAction,
  disableMallActions,
  enableManageMallActions,
  activeTab,
  currencySymbol,
  currentTab,
  initialSearch,
  filterOpts,
  queryVariables,
  isOpsAdminView,
  tabs,
  openModal,
  openGenerateModal,
  onAdd,
  onAll,
  onSearchChange,
  onFilterChange,
  onTabChange,
  onTabDelete,
  onTabSave,
  onOverrideStatus,
  onUpdateStatus,
  onAssignRunner,
  onSubmitRunner,
  setOrderMallId,
  ...listProps
}) => {
  const intl = useIntl();

  const forExclusions = disableMallActions ? [StoreOrderFilterKeys.mall] : null;

  const filterStructure = createFilterStructure(
    intl,
    filterOpts,
    forExclusions
  );

  const handlePrintLabel = ({ page }) => {
    generatePdf({ pageCount: page }, "/generate-parcel-barcodes");
  };

  const [openGenerateParcelIdModal, setOpenGenerateParcelIdModal] = useState(
    false
  );

  const { user } = useUser();

  return (
    <Container>
      <PageHeader title={intl.formatMessage(sectionNames.storeOrder)}>
        {(user.userType.code === SmopUserTypeCode.OMI_OPS ||
          enableManageMallActions) && (
          <Button
            color="default"
            variant="contained"
            style={
              disableAction
                ? { backgroundColor: "#00000033", color: "#FFFFFF" }
                : { backgroundColor: "#0030FF", color: "#FFFFFF" }
            }
            onClick={() => setOpenGenerateParcelIdModal(true)}
            disabled={disableAction}
          >
            <span style={{ color: "#FFFFFF" }}>Generate Parcel ID</span>
          </Button>
        )}
      </PageHeader>
      <Card>
        <FilterBar
          currencySymbol={currencySymbol}
          currentTab={currentTab}
          initialSearch={initialSearch}
          openModal={openModal}
          onAll={onAll}
          onFilterChange={onFilterChange}
          onSearchChange={onSearchChange}
          onTabChange={onTabChange}
          onTabDelete={onTabDelete}
          onTabSave={onTabSave}
          tabs={tabs}
          allTabLabel={intl.formatMessage({
            defaultMessage: "All",
            description: "tab name"
          })}
          filterStructure={filterStructure}
          searchPlaceholder={intl.formatMessage({
            defaultMessage: "Search Orders..."
          })}
          queryVariables={queryVariables}
          activeTab={activeTab}
          isAllAtStart={isOpsAdminView}
        />
        <StoreOrderList
          {...listProps}
          onOverrideStatus={onOverrideStatus}
          onUpdateStatus={onUpdateStatus}
          onAssignRunner={onAssignRunner}
          onSubmitRunner={onSubmitRunner}
          disableAction={disableAction}
          disableMallActions={disableMallActions}
          enableManageMallActions={enableManageMallActions}
          setOrderMallId={setOrderMallId}
        />
      </Card>
      <GenerateParcelIdDialog
        onGenerate={count => {
          handlePrintLabel({ page: count });
        }}
        open={openGenerateParcelIdModal}
        handleClose={() => {
          setOpenGenerateParcelIdModal(false);
        }}
      />
    </Container>
  );
};
StoreOrderListPage.displayName = "StoreOrderListPage";
export default StoreOrderListPage;
